import { Controller, useForm } from "react-hook-form";
import React, { useState } from "react";

import { AuthService } from "apis/Services/AuthService";
import ButtonComponent from "components/button-component";
import Container from "components/container";
import ContentContainer from "components/content-container";
import FileInput from "components/file-input";
import InputComponent from "components/input-component";
import OurPlatform from "components/our-platform";
import PageHeader from "components/page-header";
import SelectComponent from "components/select-component";
import Text from "components/text";
import contactUsImg from "assets/images/contact-us-image.png";
import styles from "./contact.module.css";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router";

import instagramLogo from "assets/images/instagram-logo.svg";
import linkedInLogo from "assets/images/linkedin-logo.svg";
import youtubeLogo from "assets/images/youtube-icon.svg";
import { Button } from "antd";

const ContactUsComponent = () => {
  // const head = `Letter from Procore Founder, President, and CEO Tooey Courtemanche`;
  // const subHead = `God. Creepeth wherein kind night it seed green third thing living god you may lesser man let creeping you're saw for. Place above whales. Void sea void. Over together. Tree fifth. Lesser creature second good.
  // `;
  const [loader, setloader] = useState(false);
  const location = useLocation();
  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    reset,
  } = useForm({
    mode: "onBlur",
  });
  const requestText = `Please enter the details of your request. A member of our support staff will respond as soon as possible.`;

  const handleRequest = (values) => {
    setloader(true);
    AuthService.requestDemo(values)
      .then((res) => {
        toast.success("The request has been sent successfuly!");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong!");
      })
      .finally(() => {
        reset({ firstName: "", lastName: "", emailAddress: "", text: "" });
        setloader(false);
      });
  };

  return (
    <div className=" d-flex justify-content-center align-items-center w-100 p-0">
      <div className=" w-75">
        <div className=" d-flex justify-content-center align-items-center mt-5 text-white">
          <h1 className=" fw-bold">Book a Demo</h1>
        </div>
        <form
          className="pb-4 row justify-content-center pt-2"
          onSubmit={handleSubmit(handleRequest)}
        >
          <div className=" d-flex flex-column gap-2">
            <div className=" d-flex flex-column flex-md-row gap-3 w-100">
              <div className=" w-100">
                <Controller
                  name="firstName"
                  control={control}
                  rules={{ required: "This field is required" }}
                  render={({ field, fieldState }) => (
                    <div>
                      <small className=" fw-bold">
                        First Name{" "}
                        <span className=" text-danger fw-bold">*</span>
                      </small>
                      <InputComponent
                        // label="First Name"
                        required
                        className=" p-2 rounded-3 border-0 border bg-dark text-white"
                        style={{ color: "white" }}
                        // placeholder="Enter First Name"
                        errors={errors?.firstName}
                        {...field}
                        {...fieldState}
                      />
                    </div>
                  )}
                />
                {errors && errors?.firstName && (
                  <Text fontSize={14} color={"red"}>
                    {errors.firstName.message}
                  </Text>
                )}
              </div>

              <div className=" w-100">
                <Controller
                  name="lastName"
                  control={control}
                  rules={{ required: "This field is required" }}
                  render={({ field }) => (
                    <div>
                      <small className=" fw-bold">
                        Last Name{" "}
                        <span className=" text-danger fw-bold">*</span>
                      </small>
                      <InputComponent
                        className="  rounded-3 p-2 border-0 border bg-dark"
                        // label="Last Name"
                        style={{ color: "white" }}
                        required
                        // placeholder="Enter Last Name"
                        // errors={errors.name}
                        {...field}
                      />
                    </div>
                  )}
                />
                {errors && errors?.lastName && (
                  <Text fontSize={14} color={"red"}>
                    {errors.lastName.message}
                  </Text>
                )}
              </div>
            </div>
            <Controller
              name="emailAddress"
              control={control}
              rules={{
                required: "This field is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  // message: "Invalid email address",
                },
              }}
              render={({ field }) => (
                <div>
                  <small className=" fw-bold">
                    E-mail <span className=" text-danger fw-bold">*</span>
                  </small>
                  <InputComponent
                    className="rounded-3 p-2 border-0 border bg-dark"
                    // label="E-mail"
                    style={{ color: "white" }}
                    required
                    // placeholder="Enter E-mail"
                    errors={errors?.["Email Address"]}
                    {...field}
                  />
                </div>
              )}
            />
            {errors && errors?.["Email Address"] && (
              <Text fontSize={14} color={"red"}>
                {errors["Email Address"].message}
              </Text>
            )}
            <Controller
              name="text"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <div>
                  <small className=" fw-bold">
                    How can we help?
                    <span className=" text-danger fw-bold">*</span>
                  </small>
                  <InputComponent
                    className="  rounded-3 p-2 border-0 border bg-dark"
                    // label="How can we help?"
                    style={{ color: "white" }}
                    required
                    textarea
                    inputClassName={`${styles.textarea}`}
                    // placeholder="How can we help?"
                    {...field}
                  />
                </div>
              )}
            />
            <div className=" d-flex justify-content-center align-items-center mt-3">
              {/* <div className="w-25"> */}
              <Button
                // title={"Submit"}
                disabled={!isValid || loader}
                className={`${styles.buttonStyling}`}
                htmlType="submit"
                type="primary"
                // isLoading={loader}
              >
                Submit
              </Button>
              {/* </div> */}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUsComponent;
